<template>
    <SwitchGroup as="div" class="flex items-center mr-4 md:flex">
        <!-- ANFORDERUNGEN-V2, Grundregel (2026-08-11): "Jedes Bedienelement —
             Kästchen, SCHALTER, Auswahlfeld, Fokusrahmen — erscheint in der
             Markenfarbe." Eingeschaltet war der Schalter bisher
             `minplan-lightgreybeige`, der Fokusrahmen `minplan-beige`; beides
             ist jetzt `minplan-blue` (#2f3441). Wirkt auf alle Verwendungen:
             Projekte-, Unternehmer- und Options-Übersicht sowie den
             MwSt-Umschalter der Abrechnung. -->
        <!-- `compact` verkleinert Schalter UND Beschriftung für Stellen, an
             denen der Umschalter neben Textaktionen steht und sonst schwerer
             wiegt als sie (Abrechnungs-Kopfzeile: neben «Spalten verwalten»
             und «Abrechnung»). Die vier Bestandsverwendungen bleiben ohne die
             Prop unverändert. -->
        <Switch
            v-model="value"
            :class="[
                value ? 'bg-minplan-blue' : 'bg-gray-200',
                compact ? 'h-5 w-9' : 'h-6 w-11',
                'relative inline-flex flex-shrink-0 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-minplan-blue',
            ]"
        >
            <span
                aria-hidden="true"
                :class="[
                    compact
                        ? value
                            ? 'translate-x-4'
                            : 'translate-x-0'
                        : value
                        ? 'translate-x-5'
                        : 'translate-x-0',
                    compact ? 'h-4 w-4' : 'h-5 w-5',
                    'pointer-events-none inline-block rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200',
                ]"
            />
        </Switch>
        <SwitchLabel as="span" :class="compact ? 'ml-2' : 'ml-3'">
            <span
                :class="
                    compact
                        ? 'text-sm text-minplan-darkgreybeige'
                        : 'text-sm font-medium text-gray-900'
                "
                >{{ label }}</span
            >
        </SwitchLabel>
    </SwitchGroup>
</template>

<script>
import { Switch, SwitchGroup, SwitchLabel } from "@headlessui/vue";

export default {
    props: {
        label: { type: String },
        modelValue: { type: Boolean, default: false },
        // Kleinere Bauform samt leichterer Beschriftung. Default `false` —
        // die vier Bestandsverwendungen bleiben unveraendert.
        compact: { type: Boolean, default: false },
    },
    emits: ["update:modelValue"],
    components: {
        SwitchLabel,
        Switch,
        SwitchGroup,
    },
    computed: {
        value: {
            get() {
                return this.modelValue;
            },
            set(val) {
                this.$emit("update:modelValue", val);
            },
        },
    },
};
</script>

<style scoped></style>
